import { ThemeAPI } from '@ingestro/importer-react'

// See reviewEntries.ts for explanation on why we use f0 CSS custom properties directly.
export const popoverInfo: ThemeAPI['popoverInfo'] = {
  color: 'hsl(var(--white-100))', // f1-foreground-inverse
  backgroundColor: 'hsl(var(--neutral-solid-50))',
  borderColor: 'hsl(var(--neutral-solid-50))',
}
